import { httpClient } from '@/shared/lib/axios';

import type { PaginatedList, PaginationParams } from '../types/pagination.types';
import type { Brand } from './brands.types';

export type BrandParams = PaginationParams & {
  query?: string;
};

export const BrandApi = {
  fetchBrands: async (params?: BrandParams) => {
    const { data } = await httpClient.get<PaginatedList<'items', Brand>>(`brands`, { params });

    return data;
  },
};
